import React from "react";
import Logo from "../../ui/Logo";
import PageSettingsDropdown from "../../ui/PageSettingsDropdown";
import { usePageSettings } from "../../../contexts/PageSettingsContext";
import { getFooterNavLinks } from "../../../utils/getFooterNavLinks";
import { Menu, Disclosure, MenuItems, DisclosureButton, DisclosurePanel, MenuItem } from "@headlessui/react";
import { useState } from "react";
import { IoChevronDown } from "react-icons/io5";
import { Link, navigate } from "gatsby";
import { constructUrl } from "../../../utils/constructUrl";
import { getTranslatedUrl } from "../../../utils/getTranslatedUrl";
import { getTranslatedCityName } from "../../../utils/getTranslatedCityName";
import { RxHamburgerMenu } from "react-icons/rx";


const CheckoutLayout = ({ pageContext, children }) => {
    const { translations } = usePageSettings();

    const { about, contact } = getFooterNavLinks(pageContext);
    const legalLink = about.find((item) => item.name === "FooterCompany_Legal");
    const presenceLink = contact.find((item) => item.name === "FooterPresenceLink");
    const [isHamburguerOpen, setIsHamburguerOpen] = useState(false);

    return (
        <>
            <nav className="w-full p-4 xl:px-0 xl:pb-0 md:container relative md:mx-auto">
                <div className="flex w-full items-center relative justify-between h-[49px]">
                    <div className="flex w-[100px]">
                        <Logo pageContext={pageContext} />
                    </div>
                    <div className="p-0">
                        <div className="hidden md:block">
                            <PageSettingsDropdown translations={translations} />
                        </div>

                        <div className="block md:hidden">
                            <Menu as="div" onClose={() => setIsHamburguerOpen(false)}>
                                <Menu.Button id="hamburger-menu-button" aria-label="Open hamburger menu">
                                    <RxHamburgerMenu
                                        color="#F7F7F7"
                                        className="h-10 w-10 p-1"
                                        onClick={() => setIsHamburguerOpen(!isHamburguerOpen)}
                                    />
                                </Menu.Button>
                                {isHamburguerOpen && (
                                    <HamburgerMenuCheckout
                                        translations={translations}
                                        isOpen={isHamburguerOpen}
                                        setOpen={setIsHamburguerOpen}
                                        citySlug={pageContext.city}
                                        countrySlug={pageContext.country}
                                    />
                                )}
                            </Menu>
                            <HamburgerMenuCheckout translations={translations} pageContext={pageContext} />

                        </div>
                    </div>
                </div>
            </nav>

            <main>{children}</main>

            <footer className="container flex flex-col gap-7 px-4 w-full mx-auto md:border-t border-ipxon-light-blue-gray md:border-0 md:px-0">
                <div className="flex justify-between pt-7">
                    <Logo pageContext={pageContext} />
                    <div className="flex gap-10">
                        <p className="text-ipxon-white text-xs font-bold border-l border-ipxon-blue-gray pl-2.5 h-fit">
                            <Link to={presenceLink?.href || "#"}>
                                <strong>{translations["FooterContactPresence"]}</strong>
                            </Link>{" "}</p>
                        <p className="text-ipxon-white text-xs font-normal border-l border-ipxon-blue-gray pl-2.5 h-fit">
                            <Link to={legalLink?.href || "#"}>
                                <strong>{translations["FooterCompany_Legal"]}</strong>
                            </Link>{" "}
                        </p>
                    </div>
                </div>

                <div className="flex justify-between items-center">
                    <p className="text-xs font-normal text-ipxon-blue-gray">
                        Copyright © {new Date().getFullYear()} IPXON Networks. All rights reserved.
                    </p>
                    <a href="https://www.conexum.co/" target="_blank" rel="noreferrer">
                        <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M20.7085 16.5675C21.8992 14.3032 22.2836 11.6551 21.7907 9.11174C21.2978 6.56834 19.961 4.30119 18.0268 2.72852C20.3869 5.32445 20.4997 10.4203 18.079 15.0051C15.6583 19.5898 11.5062 22.1701 8.1853 21.3978C10.4687 22.3214 12.9859 22.3422 15.2824 21.4565C17.5789 20.5707 19.5034 18.8367 20.7085 16.5675Z" fill="#303E42" />
                            <path d="M3.92938 7.10266C6.34796 2.50892 10.5022 -0.0602762 13.823 0.709812C11.5379 -0.21572 9.01826 -0.236785 6.71983 0.650385C4.4214 1.53755 2.4959 3.2744 1.29149 5.54687C0.100798 7.81122 -0.283585 10.4593 0.20928 13.0028C0.702145 15.5462 2.039 17.8134 3.97323 19.3861C1.62148 16.7946 1.5087 11.6964 3.92938 7.10266Z" fill="#303E42" />
                        </svg>
                    </a>
                </div>
            </footer>
        </>
    )
};

const HamburgerMenuCheckout = ({
    isOpen,
    setOpen,
    translations,
    pageContext
}) => {
    const { pageSettingsContext, availableCurrencies, currency, language, changeCurrency, changeLanguage } = usePageSettings();
    const [toggled, setToggled] = useState(false);
    const [isHamburguerOpen, setIsHamburguerOpen] = useState(false);

    const handleLanguageChange = (selectedLanguage) => {
        const { hasCityInUrl, isCountryHomepage, isHomepage, city, country, type, isDf, baseUrl } = pageSettingsContext;
        let completeTargetUrl = "#";

        if (isHomepage) {
            completeTargetUrl = getTranslatedUrl(selectedLanguage, isDf ? "/df" : "/");
        } else if (hasCityInUrl && type === "homepage") {
            completeTargetUrl = `${getTranslatedUrl(selectedLanguage, baseUrl)}/${country}/${city}`;
        } else if (isCountryHomepage) {
            completeTargetUrl = `${getTranslatedUrl(selectedLanguage, baseUrl)}/${country}`;
        } else {
            completeTargetUrl = isDf
                ? `/${selectedLanguage}/df${getTranslatedUrl(selectedLanguage, baseUrl)}`
                : `${getTranslatedUrl(selectedLanguage, "/")}/${country}${hasCityInUrl ? `/${getTranslatedCityName(selectedLanguage, city)}` : ""}${getTranslatedUrl(selectedLanguage, baseUrl)}`;
        }

        changeLanguage(selectedLanguage);
        navigate(completeTargetUrl);
    };

    const handleCurrencyChange = (selectedCurrency) => {
        changeCurrency(selectedCurrency);
        setOpen(!isOpen);
    };

    return (
        <div className="z-50 w-full flex">
            {isOpen && (
                <MenuItems static className="absolute z-[100] h-[calc(100vh-4rem)] overflow-y-auto top-16 left-0 w-full rounded-lg divide-x divide-ipxon-light-blue-gray text-white">
                    {/* <Language and Currency Dropdown/> */}
                    <Disclosure defaultOpen={true}>
                        {({ open }) => (
                            <>
                                <DisclosureButton
                                    id="b1"
                                    onClick={() => setToggled(false)}
                                    className="flex uppercase w-full px-8 py-4 justify-between rounded-0 text-left text-sm font-bold bg-ipxon-dark-gray"
                                >
                                    <p className="flex items-center gap-2">
                                        <span>{language}</span>-<span>{currency}</span>
                                    </p>
                                    <IoChevronDown
                                        className={`transform duration-200 hover:text-ipxon-magenta ${open ? "text-ipxon-magenta " : "rotate-180 "
                                            } h-5 w-5 `}
                                        onClick={() => setToggled(!toggled)}
                                    />
                                </DisclosureButton>
                                <DisclosurePanel className="p-8 pt-2 text-left text-sm flex flex-col gap-5 bg-ipxon-black">
                                    <div className=" divide-white">
                                        <h4 className="uppercase text-base text-start py-4 font-bold">
                                            {translations["language"]}
                                        </h4>
                                        <ul className="grid grid-cols-2 gap-4">
                                            <button
                                                className={`uppercase flex gap-1 bg-ipxon-light-blue-gray hover:bg-ipxon-blue-gray text-sm duration-500 transition-all rounded-lg p-2 items-center justify-center ${language === "en" && "font-bold !bg-ipxon-blue-gray"
                                                    }`}
                                                onClick={() => handleLanguageChange("en")}
                                            >
                                                EN
                                            </button>
                                            <button
                                                className={`uppercase flex gap-1 bg-ipxon-light-blue-gray hover:bg-ipxon-blue-gray text-sm duration-500 transition-all rounded-lg p-2 items-center justify-center ${language === "es" && "font-bold !bg-ipxon-blue-gray"
                                                    }`}
                                                onClick={() => handleLanguageChange("es")}
                                            >
                                                ES
                                            </button>
                                        </ul>
                                    </div>
                                    <div className="border-t border-dotted divide-dotted border-gray-500 pt-6 grid grid-cols-2 gap-5">
                                        <h4 className="col-span-full text-base text-start uppercase font-bold">
                                            {translations["Currency"]}
                                        </h4>
                                        {availableCurrencies
                                            ? availableCurrencies.map((availableCurrency) => (
                                                <button
                                                    className={`uppercase flex gap-1 bg-ipxon-light-blue-gray hover:bg-ipxon-blue-gray text-sm duration-500 transition-all rounded-lg p-2 items-center justify-center ${currency === availableCurrency.code
                                                        ? "font-bold !bg-ipxon-blue-gray"
                                                        : "font-normal"
                                                        }`}
                                                    onClick={() => handleCurrencyChange(availableCurrency.code)}
                                                    key={availableCurrency.code}
                                                >
                                                    <span>{availableCurrency.code.toUpperCase()}</span>
                                                    <span>({availableCurrency.symbol})</span>
                                                </button>
                                            ))
                                            : null}
                                    </div>
                                </DisclosurePanel>
                            </>
                        )}
                    </Disclosure>
                </MenuItems>
            )}
        </div>
    );
};

export default CheckoutLayout;
